/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Deprecated: use mcpServers.update. Where the hosted MCP is accessible: public_only, dual, or private_only
 *
 * @deprecated enum: Use mcpServers.update instead.
 */
export const UpdateToolsetRequestBodyNetworkAccessMode = {
  PublicOnly: "public_only",
  Dual: "dual",
  PrivateOnly: "private_only",
} as const;
/**
 * Deprecated: use mcpServers.update. Where the hosted MCP is accessible: public_only, dual, or private_only
 *
 * @deprecated enum: Use mcpServers.update instead.
 */
export type UpdateToolsetRequestBodyNetworkAccessMode = ClosedEnum<
  typeof UpdateToolsetRequestBodyNetworkAccessMode
>;

export type UpdateToolsetRequestBody = {
  /**
   * Deprecated: use mcpEndpoints.create or mcpEndpoints.update. The ID of the custom domain to use for the toolset
   *
   * @deprecated field: Use mcpEndpoints.create or mcpEndpoints.update instead.
   */
  customDomainId?: string | undefined;
  /**
   * The slug of the environment to use as the default for the toolset
   */
  defaultEnvironmentSlug?: string | undefined;
  /**
   * The new description of the toolset
   */
  description?: string | undefined;
  /**
   * Deprecated: use mcpServers.update. Whether the toolset is enabled for MCP
   *
   * @deprecated field: Use mcpServers.update instead.
   */
  mcpEnabled?: boolean | undefined;
  /**
   * Deprecated: use mcpServers.update. Whether the toolset is public in MCP
   *
   * @deprecated field: Use mcpServers.update instead.
   */
  mcpIsPublic?: boolean | undefined;
  /**
   * Deprecated: use mcpEndpoints.create or mcpEndpoints.update. The slug of the MCP to use for the toolset
   *
   * @deprecated field: Use mcpEndpoints.create or mcpEndpoints.update instead.
   */
  mcpSlug?: string | undefined;
  /**
   * The new name of the toolset
   */
  name?: string | undefined;
  /**
   * Deprecated: use mcpServers.update. Where the hosted MCP is accessible: public_only, dual, or private_only
   *
   * @deprecated field: Use mcpServers.update instead.
   */
  networkAccessMode?: UpdateToolsetRequestBodyNetworkAccessMode | undefined;
  /**
   * List of prompt template names to include (note: for actual prompts, not tools)
   */
  promptTemplateNames?: Array<string> | undefined;
  /**
   * List of resource URNs to include in the toolset
   */
  resourceUrns?: Array<string> | undefined;
  /**
   * The mode to use for tool selection
   */
  toolSelectionMode?: string | undefined;
  /**
   * List of tool URNs to include in the toolset
   */
  toolUrns?: Array<string> | undefined;
};

/** @internal */
export const UpdateToolsetRequestBodyNetworkAccessMode$outboundSchema:
  z.ZodMiniEnum<typeof UpdateToolsetRequestBodyNetworkAccessMode> = z.enum(
    UpdateToolsetRequestBodyNetworkAccessMode,
  );

/** @internal */
export type UpdateToolsetRequestBody$Outbound = {
  custom_domain_id?: string | undefined;
  default_environment_slug?: string | undefined;
  description?: string | undefined;
  mcp_enabled?: boolean | undefined;
  mcp_is_public?: boolean | undefined;
  mcp_slug?: string | undefined;
  name?: string | undefined;
  network_access_mode?: string | undefined;
  prompt_template_names?: Array<string> | undefined;
  resource_urns?: Array<string> | undefined;
  tool_selection_mode?: string | undefined;
  tool_urns?: Array<string> | undefined;
};

/** @internal */
export const UpdateToolsetRequestBody$outboundSchema: z.ZodMiniType<
  UpdateToolsetRequestBody$Outbound,
  UpdateToolsetRequestBody
> = z.pipe(
  z.object({
    customDomainId: z.optional(z.string()),
    defaultEnvironmentSlug: z.optional(z.string()),
    description: z.optional(z.string()),
    mcpEnabled: z.optional(z.boolean()),
    mcpIsPublic: z.optional(z.boolean()),
    mcpSlug: z.optional(z.string()),
    name: z.optional(z.string()),
    networkAccessMode: z.optional(
      UpdateToolsetRequestBodyNetworkAccessMode$outboundSchema,
    ),
    promptTemplateNames: z.optional(z.array(z.string())),
    resourceUrns: z.optional(z.array(z.string())),
    toolSelectionMode: z.optional(z.string()),
    toolUrns: z.optional(z.array(z.string())),
  }),
  z.transform((v) => {
    return remap$(v, {
      customDomainId: "custom_domain_id",
      defaultEnvironmentSlug: "default_environment_slug",
      mcpEnabled: "mcp_enabled",
      mcpIsPublic: "mcp_is_public",
      mcpSlug: "mcp_slug",
      networkAccessMode: "network_access_mode",
      promptTemplateNames: "prompt_template_names",
      resourceUrns: "resource_urns",
      toolSelectionMode: "tool_selection_mode",
      toolUrns: "tool_urns",
    });
  }),
);

export function updateToolsetRequestBodyToJSON(
  updateToolsetRequestBody: UpdateToolsetRequestBody,
): string {
  return JSON.stringify(
    UpdateToolsetRequestBody$outboundSchema.parse(updateToolsetRequestBody),
  );
}
